import { Injectable } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { BackupApiService } from './backup-api.service';
import { BackupService } from './backup.service';
import { DocumentsStorageService } from './documents-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DbCleanupService {
  constructor(
    private readonly storageService: DocumentsStorageService,
    private readonly backupApiService: BackupApiService,
    private readonly backupService: BackupService,
  ) { }

  public async cleanupDbData(): Promise<void> {
    const currentUser = this.getCurrentUser();
    if (currentUser == null) {
      return;
    }
    const serverBackupIds: number[] = await this.findServiceBackupIds();
    if (serverBackupIds.length === 0) {
      return;
    }
    await Promise.all([
      firstValueFrom(this.storageService.deleteOutdatedDocs(serverBackupIds)),
      this.backupService.deleteOutdatedBackups(serverBackupIds)
    ]);
  }

  private async findServiceBackupIds(): Promise<number[]> {
    return firstValueFrom(this.backupApiService.getAllBackupListWithVersion().pipe(
      map(response => response.data?.backupVersions?.map(item => item.id) || [])
    ));
  }

  private getCurrentUser(): string | null {
    const currentUser = localStorage.getItem('login');
    return currentUser == null || currentUser.trim().length === 0 ? null : currentUser;
  }
}
